const INITIAL_TAB = 'initialResearchIndexTab';
export const getInitialTab = () => window.localStorage.getItem(INITIAL_TAB);
export const setInitialTab = value => window.localStorage.setItem(INITIAL_TAB, value);
